const CLASSIFIEDS_BASE_PATH = '/embarcacoes';

const normalizeSlug = (slug: unknown): string => {
    if (typeof slug !== 'string') {
        return '';
    }

    const trimmedSlug = slug.trim();

    if (!trimmedSlug) {
        return '';
    }

    try {
        return decodeURIComponent(trimmedSlug);
    } catch {
        return trimmedSlug;
    }
};

export const buildClassifiedPath = (slug: unknown): string => {
    const normalizedSlug = normalizeSlug(slug);

    if (!normalizedSlug) {
        return CLASSIFIEDS_BASE_PATH;
    }

    return `${CLASSIFIEDS_BASE_PATH}/${encodeURIComponent(normalizedSlug)}`;
};

export const buildClassifiedAbsoluteUrl = (appUrl: unknown, slug: unknown): string => {
    const path = buildClassifiedPath(slug);
    const base = typeof appUrl === 'string' ? appUrl.trim() : '';

    if (!base) {
        if (typeof window === 'undefined') {
            return path;
        }

        return new URL(path, window.location.origin).toString();
    }

    const normalizedBase = base.endsWith('/') ? base : `${base}/`;

    return new URL(path, normalizedBase).toString();
};
